export default "__VITE_ASSET__CLDdL8R6__";